import {setupTabs} from "./setupTabs";

function setVisible(node, visible) {
    if (node) {
        node.classList.toggle("is-hidden", !visible);
    }
}

function hideExistingResult() {
    const result = document.getElementById("bodyStandardResult");
    if (result) {
        result.classList.add("is-hidden");
    }
    const about = document.querySelector(".calculator__about");
    if (about) {
        about.classList.remove("is-hidden-mobile");
    }
}

function initBodyMeasurementCalculator() {
    const form = document.querySelector("[data-body-measurement-calculator-form]");
    if (!form) {
        return null;
    }

    const standardInput = form.querySelector("[data-body-standard-input]");
    const standardSelect = form.querySelector("[data-body-standards-switcher-select]");
    const unitInput = form.querySelector("[data-body-standard-unit-input]");
    const heightMajorInput = form.querySelector("[data-body-standard-height-major]");
    const heightMajorUnit = form.querySelector("[data-body-standard-height-major-unit] .button");
    const heightMinorInput = form.querySelector("[data-body-standard-height-minor]");
    const heightMinorContainer = form.querySelector("[data-body-standard-height-minor-container]");
    const heightMinorUnit = form.querySelector("[data-body-standard-height-minor-unit]");
    const valueLabel = form.querySelector("[data-body-standard-value-label]");
    const valueInput = form.querySelector("[data-body-standard-value]");
    const submitButton = form.querySelector("[data-body-standard-submit]");
    let currentOption = standardSelect.options[standardSelect.selectedIndex];

    function setUnit(unit, resetValues, hideResult) {
        const isMetric = unit === "cm";
        unitInput.value = isMetric ? "cm" : "in";
        heightMajorInput.name = isMetric ? "height" : "height_feet";
        heightMajorInput.min = isMetric ? "120" : "3";
        heightMajorInput.max = isMetric ? "230" : "7";
        heightMajorInput.step = isMetric ? "0.1" : "1";
        heightMajorInput.placeholder = isMetric ? "170" : "5";
        heightMajorUnit.textContent = isMetric ? "cm" : "ft";
        heightMinorInput.disabled = isMetric;
        setVisible(heightMinorContainer, !isMetric);
        setVisible(heightMinorUnit, !isMetric);
        valueInput.placeholder = isMetric
            ? currentOption.dataset.placeholderCm
            : currentOption.dataset.placeholderIn;

        if (resetValues) {
            heightMajorInput.value = "";
            heightMinorInput.value = "";
            valueInput.value = "";
        }
        if (hideResult) {
            hideExistingResult();
        }
    }

    function selectStandard(option, resetValue, hideResult) {
        if (!option) {
            return;
        }

        currentOption = option;
        standardInput.value = option.dataset.standard;
        standardSelect.value = option.dataset.standard;
        valueLabel.textContent = option.dataset.label;
        submitButton.textContent = "Check " + option.dataset.label + " Size";
        valueInput.placeholder = unitInput.value === "cm"
            ? option.dataset.placeholderCm
            : option.dataset.placeholderIn;
        if (resetValue) {
            valueInput.value = "";
        }
        if (hideResult) {
            hideExistingResult();
        }
    }

    unitInput.addEventListener("change", function () {
        setUnit(unitInput.value, true, true);
    });
    standardSelect.addEventListener("change", function () {
        selectStandard(standardSelect.options[standardSelect.selectedIndex], true, true);
    });
    selectStandard(currentOption, false, false);
}

function initBodyweightCalculator() {
    const form = document.querySelector("[data-bodyweight-calculator-form]");
    if (!form) {
        return;
    }

    const unitInput = form.querySelector("[data-bodyweight-unit-input]");
    const valueInput = form.querySelector("[data-bodyweight-value]");
    const heightUnitInput = form.querySelector("[data-bodyweight-height-unit]");
    const heightMajorInput = form.querySelector("[data-bodyweight-height-major]");
    const heightMinorInput = form.querySelector("[data-bodyweight-height-minor]");
    const heightMinorContainer = form.querySelector("[data-bodyweight-height-minor-container]");
    const heightMinorUnit = form.querySelector("[data-bodyweight-height-minor-unit]");

    function setHeightUnit(unit, resetValues, hideResult) {
        const isMetric = unit === "cm";
        heightUnitInput.value = isMetric ? "cm" : "in";
        heightMajorInput.name = isMetric ? "height" : "height_feet";
        heightMajorInput.min = isMetric ? "120" : "3";
        heightMajorInput.max = isMetric ? "230" : "7";
        heightMajorInput.step = isMetric ? "0.1" : "1";
        heightMajorInput.placeholder = isMetric ? "170" : "5";
        heightMinorInput.disabled = isMetric;
        setVisible(heightMinorContainer, !isMetric);
        setVisible(heightMinorUnit, !isMetric);
        if (resetValues) {
            heightMajorInput.value = "";
            heightMinorInput.value = "";
        }
        if (hideResult) {
            hideExistingResult();
        }
    }

    unitInput.addEventListener("change", function () {
        valueInput.placeholder = unitInput.value === "kg" ? "80" : "180";
        hideExistingResult();
    });
    heightUnitInput.addEventListener("change", function () {
        setHeightUnit(heightUnitInput.value, true, true);
    });
}

function initBodyFatCalculator() {
    const form = document.querySelector("[data-body-fat-calculator-form]");
    if (!form) {
        return;
    }

    const methodInputs = form.querySelectorAll("[data-body-fat-method]");
    const estimateContainer = form.querySelector("[data-body-fat-estimate]");
    const estimateInputs = form.querySelectorAll("[data-body-fat-estimate-input]");
    const knownField = form.querySelector("[data-body-fat-known]");
    const knownInput = form.querySelector("[data-body-fat-known-input]");
    const genderInput = form.querySelector("[data-body-fat-gender]");
    const unitInput = form.querySelector("[data-body-fat-unit-input]");
    const heightMajorInput = form.querySelector("[data-body-fat-height-major]");
    const heightMinorInput = form.querySelector("[data-body-fat-height-minor]");
    const heightMinorContainer = form.querySelector("[data-body-fat-height-minor-container]");
    const heightMinorUnit = form.querySelector("[data-body-fat-height-minor-unit]");
    const hipField = form.querySelector("[data-body-fat-hip-field]");
    const hipInput = form.querySelector("[data-body-fat-hip]");
    const waistLabel = form.querySelector("[data-body-fat-waist-label]");
    const waistHelp = form.querySelector("[data-body-fat-waist-help]");
    const circumferenceInputs = form.querySelectorAll("[data-body-fat-circumference]");
    const sizeUnits = form.querySelectorAll("[data-body-fat-size-unit]");

    function selectedMethod() {
        const selected = form.querySelector("[data-body-fat-method]:checked");
        return selected ? selected.value : "estimate";
    }

    function updateEnabledInputs() {
        const known = selectedMethod() === "known";
        const metric = unitInput.value === "cm";
        const female = genderInput.value === "female";
        for (let i = 0; i < estimateInputs.length; i++) {
            estimateInputs[i].disabled = known;
        }
        if (!known) {
            heightMinorInput.disabled = metric;
            hipInput.disabled = !female;
        }
        knownInput.disabled = !known;
    }

    function updateMethod(hideResult) {
        const known = selectedMethod() === "known";
        setVisible(estimateContainer, !known);
        setVisible(knownField, known);
        updateEnabledInputs();
        if (hideResult) {
            hideExistingResult();
        }
    }

    function updateGender(hideResult) {
        const female = genderInput.value === "female";
        setVisible(hipField, female);
        waistLabel.textContent = female ? "Waist" : "Abdomen";
        waistHelp.textContent = female ? "Measure your natural waist." : "Measure at your navel.";
        updateEnabledInputs();
        if (hideResult) {
            hideExistingResult();
        }
    }

    function updateUnit(resetValues, hideResult) {
        const metric = unitInput.value === "cm";
        heightMajorInput.name = metric ? "height" : "height_feet";
        heightMajorInput.min = metric ? "120" : "3";
        heightMajorInput.max = metric ? "230" : "7";
        heightMajorInput.step = metric ? "0.1" : "1";
        heightMajorInput.placeholder = metric ? "170" : "5";
        setVisible(heightMinorContainer, !metric);
        setVisible(heightMinorUnit, !metric);
        for (let i = 0; i < sizeUnits.length; i++) {
            sizeUnits[i].textContent = metric ? "cm" : "in";
        }
        for (let i = 0; i < circumferenceInputs.length; i++) {
            const input = circumferenceInputs[i];
            if (input === hipInput) {
                input.placeholder = metric ? "95" : "37";
            } else if (input.name === "neck") {
                input.placeholder = metric ? "38" : "15";
            } else {
                input.placeholder = metric ? "85" : "33";
            }
            if (resetValues) {
                input.value = "";
            }
        }
        if (resetValues) {
            heightMajorInput.value = "";
            heightMinorInput.value = "";
        }
        updateEnabledInputs();
        if (hideResult) {
            hideExistingResult();
        }
    }

    for (let i = 0; i < methodInputs.length; i++) {
        methodInputs[i].addEventListener("change", function () {
            updateMethod(true);
        });
    }
    genderInput.addEventListener("change", function () {
        updateGender(true);
    });
    unitInput.addEventListener("change", function () {
        updateUnit(true, true);
    });

    updateUnit(false, false);
    updateGender(false);
    updateMethod(false);
}

function initBodyStandardsNavigation() {
    const select = document.querySelector("[data-body-standards-navigation-select]");
    if (select) {
        select.addEventListener("change", function () {
            window.location.assign(select.value);
        });
    }
}

function initBodyStandards() {
    setupTabs();
    initBodyMeasurementCalculator();
    initBodyweightCalculator();
    initBodyFatCalculator();
    initBodyStandardsNavigation();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBodyStandards);
} else {
    initBodyStandards();
}
